module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-bread-cumb', {
    attrs: {
      "bread-cumb": _vm.breadCumb
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "warp50"
  }, [_c('el-form', {
    ref: "userForm",
    attrs: {
      "model": _vm.userForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.username),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "username", $$v)
      },
      expression: "userForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "real_name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.real_name),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "real_name", $$v)
      },
      expression: "userForm.real_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "mobile", $$v)
      },
      expression: "userForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.userForm.email),
      callback: function($$v) {
        _vm.$set(_vm.userForm, "email", $$v)
      },
      expression: "userForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('userForm')
      }
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('userForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2f7abd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/system/user/edit.vue
// module id = 942
// module chunks = 0